import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

const CommissionModal = ({
  show,
  onHide,
  onConfirm,
  influencerName,
  modalMode,
  commision,
}) => {
  const [commissionPercent, setCommissionPercent] = useState(commision);

  useEffect(() => {
    if (show) {
      setCommissionPercent(commision ?? 10);
    }
  }, [show, commision]);

  const handleConfirm = () => {
    onConfirm(Number(commissionPercent));
    setCommissionPercent(10);
  };

  const handleClose = () => {
    setCommissionPercent(10);
    onHide();
  };

  const modalTitle =
    modalMode === "edit"
      ? "Edit Commission"
      : modalMode === "reactivate"
        ? "Re-approve Influencer"
        : "Set Commission";

  const actionLabel = modalMode === "edit" ? "Update" : "Confirm";

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="sm"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="position-relative rounded p-4">
        <div className="border-bottom pb-3 mb-3 position-relative">
          <div className="text-center d-flex align-items-center justify-content-center gap-2">
            <h6 className="m-0 fw-sbold">{modalTitle}</h6>
          </div>
          <Button
            onClick={handleClose}
            className="border-0 p-0 position-absolute"
            variant="transparent"
            style={{ right: 0, top: 0 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 16 15"
              fill="none"
            >
              <g clipPath="url(#clip0_0_6282)">
                <path
                  d="M1.98638 14.906C1.61862 14.9274 1.25695 14.8052 0.97762 14.565C0.426731 14.0109 0.426731 13.1159 0.97762 12.5617L13.0403 0.498994C13.6133 -0.0371562 14.5123 -0.00735193 15.0485 0.565621C15.5333 1.08376 15.5616 1.88015 15.1147 2.43132L2.98092 14.565C2.70519 14.8017 2.34932 14.9237 1.98638 14.906Z"
                  fill="#000"
                />
                <path
                  d="M14.0347 14.9061C13.662 14.9045 13.3047 14.7565 13.0401 14.4941L0.977383 2.4313C0.467013 1.83531 0.536401 0.938371 1.13239 0.427954C1.66433 -0.0275797 2.44884 -0.0275797 2.98073 0.427954L15.1145 12.4907C15.6873 13.027 15.7169 13.9261 15.1806 14.4989C15.1593 14.5217 15.1372 14.5437 15.1145 14.5651C14.8174 14.8234 14.4263 14.9469 14.0347 14.9061Z"
                  fill="#000"
                />
              </g>
              <defs>
                <clipPath id="clip0_0_6282">
                  <rect
                    width="15"
                    height="15"
                    fill="white"
                    transform="translate(0.564453)"
                  />
                </clipPath>
              </defs>
            </svg>
          </Button>
        </div>

        <div className="text-center mb-3">
          <p className="text-muted mb-1" style={{ fontSize: "0.85rem" }}>
            {modalMode === "edit"
              ? "Updating commission for"
              : "Approving request for"}
          </p>
          <p className="fw-sbold mb-0 text-capitalize">
            {influencerName || "—"}
          </p>
        </div>

        <Form.Group className="mb-4">
          <Form.Label className="fw-sbold mb-1">
            Commission Percent (%)
          </Form.Label>
          <Form.Control
            type="number"
            min={0}
            max={100}
            value={commissionPercent}
            onChange={(e) => setCommissionPercent(e.target.value)}
            placeholder="Enter commission %"
          />
        </Form.Group>

        <Row className="g-2">
          <Col xs={6}>
            <Button
              variant="outline-secondary"
              className="w-100"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Col>
          <Col xs={6}>
            <Button
              variant="primary"
              className="w-100"
              onClick={handleConfirm}
              disabled={
                commissionPercent === "" ||
                commissionPercent < 0 ||
                commissionPercent > 100
              }
            >
              {actionLabel}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default CommissionModal;
